var Reports = {
  selectedUCIs : {},

  run : function() {
    if ( Reports.resultTable !== undefined ) {
      Reports.resultTable.destroy();
    }

    // - SHOW THE RESULTS TABLE
    $('#report-result-container').removeClass ( 'dn' );
    
    Reports.resultTable = $('#dt-report-result')
      .DataTable({
        serverSide : true,
        processing : true,
        ajax : {
          url: '/ajax/AJAX-reports/run-report-ss-datatables',
          data: {
            filters : {
              courses  : $('select[name="report-filter-courses"]').val(),
              statuses : $('select[name="report-filter-statuses"]').val(),
              archiveStatuses : $('select[name="report-filter-archive-statuses"]').val(),
            },
          },
          type: 'POST',
          // dataType: 'text',
          // success: function(returnedData) {
          //   console.log(returnedData);
          // }
        },
        // select: true,
        select: {
          style:    'multi',
          selector: 'tr',
        },
        createdRow: function ( row, data, index ) {
          $(row)
            .attr ( 'data-uci-id', data['DT_RowData']['uciid'] )
            .attr ( 'data-archived', data['DT_RowData']['archived'] );
        },
        columns: [
          { "data": "cb" },
          { "data": "fld_first_name" },
          { "data": "fld_surname" },
          { "data": "fld_email" },
          { "data": "short_name" },
          { "data": "progress" },
          { "data": "fld_enrolled_ts" },
          { "data": "fld_date_completed" },
          // { "data": "how_long" },
        ],
        columnDefs: [{
          orderable: false,
          searchable: false,
          data: null,
          className: 'select-cb',
          defaultContent: '',
          targets:   0
        }]
      })
      .on ( 'select', function (e, dt, type, indexes) {
        if ( Reports.selectedUCIs[dt.data().DT_RowData.uciid] === undefined ) {
          Reports.selectedUCIs[dt.data().DT_RowData.uciid] = dt.data();
        }

        // - SHOW THE SUMMARY TABLE
        $('#summary-of-users-for-action').removeClass ( 'dn' );

        Reports.updateSelectedUsers();
      })
      .on ( 'deselect', function (e, dt, type, indexes) {
        delete Reports.selectedUCIs[dt.data().DT_RowData.uciid];

        if ( Object.isEmpty ( Reports.selectedUCIs ) ) {
          // - SHOW THE SUMMARY TABLE
          $('#summary-of-users-for-action').addClass ( 'dn' );
        }

        Reports.updateSelectedUsers();
      });

    Reports.summaryOfUsersForActionTable = $('#dt-summary-of-users-for-action')
      .DataTable();
  },

  runCSV : function ( onSuccess ) {
    var sendData = {
      filters : {
        courses  : $('select[name="report-filter-courses"]').val(),
        statuses : $('select[name="report-filter-statuses"]').val(),
      },
    };
    
    $.ajax({
      url: '/ajax/AJAX-reports/run-csv',
      type: 'post',
      data: sendData,
      dataType: 'json',
      success: function ( returnedData ) {
        console.log(returnedData);
        onSuccess ( returnedData );
      },
      error: function ( err ) {
        console.log(err);
      },
    });
  },

  updateSelectedUsers : function() {
    Reports.summaryOfUsersForActionTable.clear();

    for ( var id in Reports.selectedUCIs ) {
      var row = Reports.summaryOfUsersForActionTable.row.add ([
        Reports.selectedUCIs[id].fld_first_name,
        Reports.selectedUCIs[id].fld_surname,
        Reports.selectedUCIs[id].fld_email,
        Reports.selectedUCIs[id].short_name,
        Reports.selectedUCIs[id].progress,
        Reports.selectedUCIs[id].fld_enrolled_ts,
        Reports.selectedUCIs[id].fld_date_completed,
      ]).node();

      $(row).data('uci-id', id);
    }

    Reports.summaryOfUsersForActionTable.draw();
  },

  multipleUsersAction : {
    init: function() {
      $('#report-multiple-users-action')
        .off ( 'change' )
        .on  ( 'change', function ( evt ) {
          switch ( $(this).val() ) {
            case 'reset':
              popup.generatePopup({
                title: 'Reset Selected Users Course Enrolments?',
                content: '<style>.popup-content { text-align: center; }</style><button id="reset-course-progress-btn" class="gen-btn positive-btn">Confirm</button>',
                maxWidth: 420,
                maxHeight: 140,
                success: function ( returnedData ) {
                  // console.log('reset button initialised');
                  $('#reset-course-progress-btn')
                    .on ( 'click', function ( evt ) {
                      Reports.multipleUsersAction.resetUserProgress();
                    });
                }
              });
              break;
            case 'reset-passwords':
              popup.generatePopup({
                title: 'Reset User Passwords',
                method: 'ajax',
                ajaxUrl: '/ajax/AJAX-users/show-reset-passwords-form',
                maxWidth: 1000,
                maxHeight: 600,
                data : {
                  selectedUCIs : Reports.selectedUCIs,
                },
                success: function(returnedData) {
                  console.log(returnedData);
                },
              });
              break;
            case 'archive':
              popup.generatePopup({
                title: 'Archive Selected Users?',
                content: '<button id="confirm-archive-ucis-btn" class="gen-btn positive-btn 1/1">Confirm</button>',
                width: 280,
                height: 140,
                success: function() {
                  $('#confirm-archive-ucis-btn')
                    .off ( 'click' )
                    .on  ( 'click', function ( evt ) {
                      var sendData = {
                        selectedUCIs : Reports.selectedUCIs,
                      };
                      
                      $.ajax({
                        url: '/ajax/AJAX-users/archive-users',
                        type: 'post',
                        data: sendData,
                        dataType: 'json',
                        success: function ( returnedData ) {
                          console.log(returnedData);
                          if ( returnedData.success ) {
                            popup.close();
                          }
                        },
                        error: function ( err ) {
                          console.log(err);
                        },
                      });
                    });
                },
              });
              break;
            default:
              break;
          }
        })
    },

    resetUserProgress : function() {
      var sendData = {
        selectedUCIs : Reports.selectedUCIs,
      };
      
      $.ajax({
        url: '/ajax/AJAX-users/archive-and-reset-users',
        type: 'post',
        data: sendData,
        dataType: 'json',
        success: function ( returnedData ) {
          console.log(returnedData);
        },
        error: function ( err ) {
          console.log(err);
        },
      });
      
    },
  },
};